document.addEventListener("DOMContentLoaded", () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate");
        }
      });
    },
    { threshold: 0.25 }
  );

  document.querySelectorAll(".rewards-fade, .rewards-scale, .rewards-heading")
    .forEach((el) => observer.observe(el));

  // Image animation
  const imgObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) entry.target.classList.add("rewards-image-animate");
    });
  });

  document.querySelectorAll(".referral-image img")
    .forEach((el) => imgObserver.observe(el));
});
